<bolt-header class="header-help">
    <div slot="search">
        <div>
            <span class="need-help">Need help? </span>
            <span class="call-us">Call our Life Insurance Solutions Center at </span>
            <span class="text-phone">1-800-848-6331</span>
            <span class="call-us">.</span>

        </div>
    </div>
       
</bolt-header>
<div class="mobile-help">
    <span class="need-help" (click) = "toggleHelp($event)" >Need help? <span class="question-mark">?</span></span>

    <div *ngIf="showHelp" class="help-popup">
        <p>Call our Life Insurance Solutions Center at <a href="tel:18008486331"><span class="text-phone">1-800-848-6331</span></a></p>
    </div>
    
</div>
